<template>
  <div>
    <div class="card">
      <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
        <div class="ns-container">
          <h1 class="heading-white tw-text-center">
            Charts
          </h1>
        </div>
      </section>

      <div
        v-if="showHeading"
        class="card-header"
      >
        <h3>
          Cached as of {{ cachedAt > 0 ? dayjs(cachedAt).format('YYYY-MM-DD') : dayjs(new Date()).format('YYYY-MM-DD') }}) <a
            class="tw-underline tw-text-blue-500"
            @click="refresh"
          >Refresh</a>&nbsp;|&nbsp;
          Days Range:&nbsp;
          <a
            :class="days === 14 ? 'tw-text-blue-500' : ''"
            @click="setDays(14)"
          >14</a>&nbsp;|&nbsp;
          <a
            :class="days === 30 ? 'tw-text-blue-500' : ''"
            @click="setDays(30)"
          >30</a>&nbsp;|&nbsp;
          <a
            :class="days === 60 ? 'tw-text-blue-500' : ''"
            @click="setDays(60)"
          >60</a>&nbsp;|&nbsp;
          <a
            :class="days === 90 ? 'tw-text-blue-500' : ''"
            @click="setDays(90)"
          >90</a>&nbsp;|&nbsp;
          <a
            :class="days === 365 ? 'tw-text-blue-500' : ''"
            @click="setDays(365)"
          >365</a>&nbsp;|&nbsp;
        </h3>
      </div>
      <div
        v-if="loaded"
        class="card-body"
      >
        <div class="row">
          <div
            v-for="(chart, key) in charts"
            :key="key"
            class="col-12 col-md-12 col-lg-12 col-xl-6"
          >
            <div class="card">
              <div class="card-body">
                <ChartServer
                  :chart-name="chart"
                  :api-params="apiParams"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { sync } from 'vuex-pathify';

export default {
  components: {
    ChartServer: () => import(/* webpackChunkName: "components--charts" */ '@/components/charts/ChartServer'),
  },

  data() {
    return {
      loaded: false,
      showHeading: true,
      cachedAt: 0,

      apiParams: {
        days: 0,
      },

      charts: [
        'daily-activity', //
        'active-members', //
        'signups-per-day', //
        'signups-per-month', //
        'professions', //
        'cities', //
        'countries', //
        'genders', //
        'ages', //
        'age-groups', //
        'male-matching-preferences', //
        'female-matching-preferences', //
        'sexual-orientation', //
      ],
    };
  },

  computed: {
    ...sync([
      'charts/days', //
    ]),

    dayjs() {
      return dayjs;
    },
  },

  watch: {
    days(days) {
      this.apiParams.days = days;

      Bus.$emit('refresh');
    },
  },

  created() {
    this.apiParams.days = this.days;

    this.loaded = true;
  },

  methods: {
    refresh() {
      console.log('refresh');
      Bus.$emit('refresh');
    },

    setDays(days) {
      console.log('setDays', days);
      this.days = days;
    },
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>
